import Hotjar from '@hotjar/browser';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

import { pendo } from '@portals/analytics';
import { useAuth } from '@portals/redux';

import { useCommonFeatureFlags } from './portal-config';

export function useAnalytics() {
  const auth = useAuth();
  const featureFlags = useCommonFeatureFlags();

  const location = useLocation();

  useEffect(
    function trackFeatureFlags() {
      if (featureFlags) {
        pendo.track('featureFlags', featureFlags);
      }
    },
    [featureFlags]
  );

  useEffect(
    function configurePendo() {
      // pendo.initialize() was called already
      if (pendo.isReady()) {
        if (auth && pendo.isAnonymousVisitor()) {
          // User is logged in, but Pendo visitor is still set to anonymous
          pendo.identify(auth.email, auth.tenant?.display_name);
        }
      } else {
        // pendo.initialize() wasn't called yet
        if (auth) {
          // Pendo is not ready, initializing with authenticated visitor data
          pendo.initializeAuthenticated(auth.email, auth.tenant?.display_name);
        } else {
          // Pendo is not ready, initializing with anonymous visitor data
          pendo.initializeAnonymous();
        }
      }
    },
    [auth]
  );

  useEffect(
    function trackPageViewPerPathname() {
      const userEmail = auth?.email;

      pendo.trackPageView(location.pathname, userEmail);
    },
    [auth?.email, location.pathname]
  );

  useEffect(
    function hotjarIdentifyPerPathname() {
      if (auth && Hotjar.isReady()) {
        Hotjar.identify(auth.id, {
          email: auth.email,
          name: auth.name,
          tenantDisplayName: auth.tenant.display_name,
          tenantType: auth.tenant.type,
        });
      }
    },
    [auth, location.pathname]
  );
}
